import React from 'react';

import LocationInfo from '../LocationInfo';
import Disclaimer from '../Disclaimer';

export default ({ statusDetail }) => (
  <article className="has-border-grey nbn-infobox__article content-area-white clearfix">
    <div className="one_half nbn-infobox__column">
      <p className="nbn-infobox__column__text">nbn<sup className="text-xxx-small">TM</sup> will be coming to your area, however construction is not expected to commence for at least another three years.</p>
    </div>
    <div className="one_half nbn-infobox__column">
      <LocationInfo statusDetail={statusDetail} />
      <a href="https://www.finder.com.au/broadband-plans" className="btn-link nbn-btn-link">Compare broadband plans</a>
    </div>
    <Disclaimer />
  </article>
);
